module.exports = __webpack_public_path__ + "static/media/Jim Wacksman Head Shot.4e6fa8e1.png";